import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_AND_TABLET_PORTRAIT } from 'settings/mediaQuery';
import { ScrollToTop } from 'components/Common/ScrollToTop/ScrollToTop';
import DetailsProductsDesktop from 'components/Account/MyOrder/OrderDetails/DetailsProducts/DetailsProductsDesktop/DetailsProductsDesktop';
import DetailsProductsMobile from 'components/Account/MyOrder/OrderDetails/DetailsProducts/DetailsProductsMobile/DetailsProductsMobile';
import { DataDetailledOrder } from 'types/DetailsProducts';

function DetailsProducts(props: { order: DataDetailledOrder }): JSX.Element {
  const isMobileAndPortraitTablet = useMediaQuery({
    query: MOBILE_AND_TABLET_PORTRAIT,
  });
  const [once, setOnce] = useState(false);

  useEffect(() => {
    if (!once) {
      setOnce(true);
    }
  }, []);

  return (
    <>
      {once && <ScrollToTop />}
      {!isMobileAndPortraitTablet ? (
        <DetailsProductsDesktop order={props.order} />
      ) : (
        <DetailsProductsMobile order={props.order} />
      )}
    </>
  );
}

export default DetailsProducts;
